import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import global_en from '../translation/en/global.json';
import global_sr from '../translation/sr/global.json';
import global_hu from '../translation/hu/global.json';

// Učitavanje jezika iz localStorage ili korišćenje podrazumevanog
const savedLanguage = localStorage.getItem('language') || 'sr';

i18n
  .use(initReactI18next)
  .init({
    resources: {
      en: { global: global_en },
      sr: { global: global_sr },
      hu: { global: global_hu },
    },
    lng: savedLanguage, // Koristi sačuvani jezik
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;

